import { Box, Container } from '@mui/material';

import {
  FullPageSpinnerInnerStyles,
  FullPageSpinnerStyles,
} from '@/components/ui/fullPageSpinner/fullPageSpinner.style';

function FullPageSpinner() {
  return (
    <Container>
      <Box sx={FullPageSpinnerStyles}>
        <Box sx={FullPageSpinnerInnerStyles}></Box>
      </Box>
    </Container>
  );
}

export default FullPageSpinner;
